namespace advisorop.components.servicer{

    
    export class RiskSetupController {

        // input param
        public advisoryFirmId: number;
        public afcModels: domains.IAFAssetClassnModel[] = [];
        
        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService) {
            
        }

        cuAfcModelOnModelsChange(afcModels: domains.IAFAssetClassnModel[]) {
            //console.log(`CuAfcModel onModelsChange ${afcModels}`);
            this.afcModels = afcModels;
        }
        
        loadLovs(): void {
            this.generalService.getLOVs()
                .then(data => {
                    //this.tampTypes = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.TAMP_TYPE; });
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            this.loadLovs();
        }
    }

    class RiskSetup implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<"
            };
            this.controller = RiskSetupController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/risk-setup.html";
        }
    }
    angular.module(Constants.APP).component("riskSetup", new RiskSetup());
}